import { render } from "./KapibaraAbout.vue?vue&type=template&id=461f894c"
import script from "./KapibaraAbout.vue?vue&type=script&lang=js"
export * from "./KapibaraAbout.vue?vue&type=script&lang=js"

import "./KapibaraAbout.vue?vue&type=style&index=0&id=461f894c&lang=scss"

import exportComponent from "D:\\experement\\kapibara\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__